// Clean up formatting for pasted content
export function cleanupPastedFormatting(node: HTMLElement, op: any): any {
  const unsupportedAttrs = ['code-block'];
  const unsupportedTags = ['PRE'];

  // Clean up unsupported attributes
  if (op.attributes) {
    const hasUnsupportedAttrs = Object.keys(op.attributes).some((key) => unsupportedAttrs.includes(key));
    if (hasUnsupportedAttrs) {
      return { attributes: {}, insert: op.insert };
    }
  }

  if ( unsupportedTags.includes(node.tagName) ) {
    return { attributes: { 'code-block': false }, insert: op.insert };
  }

  // Convert font size from px to pt
  if (node.style.fontSize) {
    op.attributes = {
      ...(op.attributes || {}),
      size: node.style.fontSize.includes('px')
        ? `${pxToPt(parseFloat(node.style.fontSize))}pt`
        : node.style.fontSize
    };
  }

  // Handle font family
  if (node.style.fontFamily) {
    let font = node.style.fontFamily.replace(/['"]/g, '').split(',')[0].trim().toLowerCase().replace(/\s/g, '');
    op.attributes = {
      ...(op.attributes || {}),
      font
    };
  }

  return op;
}

function pxToPt(px: number): number {
  const inches = px / 96;
  const points = inches * 72;
  return Math.round(points);
} 